import React, { ReactNode } from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { useTranslation } from "react-i18next";
import { AccountTypeEnum, AccountTypeFromBankEnum } from "@rentablo/api/apiv1";
import { Badge } from "@rentablo/components";
import AccountPreviewIcon from "@components/Accounts/AccountPreviewCard/AccountPreviewIcon";

export interface ContraAccountRowProps {
  accountName?: string;
  iban?: string;
  bankName?: string;
  bankImage?: string;
  accountNumber?: string;
  type?: AccountTypeFromBankEnum;
  accountType?: AccountTypeEnum;
  to?: string;
  action?: ReactNode;
  isPrimary?: boolean;
}

export const ContraAccountRow = ({
  accountName,
  iban,
  bankName,
  bankImage,
  accountNumber,
  type,
  accountType = "02_cash",
  to,
  action,
  isPrimary = false,
}: ContraAccountRowProps) => {
  const { t } = useTranslation();
  const accountTypeLabel = type
    ? t(`selectContraAccount.accountTypeFromBank.${type}`)
    : "";
  const details = [accountTypeLabel || bankName, iban, accountNumber].filter(
    Boolean
  );

  return (
    <Box display="flex" alignItems="center" gap={3}>
      <AccountPreviewIcon
        isReference={false}
        iconUrl={bankImage ?? ""}
        type={accountType}
        size={40}
      />
      <Box minWidth={0}>
        <Box display="flex" alignItems="center" gap={2} minWidth={0}>
          {to ? (
            <Link
              component={RouterLink}
              to={to}
              variant="body2"
              color="text.primary"
              underline="hover"
              noWrap
            >
              {accountName}
            </Link>
          ) : (
            <Typography variant="body2" noWrap>
              {accountName}
            </Typography>
          )}
          {isPrimary && (
            <Badge variant="primary" sx={{ flexShrink: 0 }}>
              {t("accounts.primaryReferenceBadge")}
            </Badge>
          )}
        </Box>
        <Typography
          variant="body4"
          color="textSecondary"
          sx={{ wordBreak: "break-word" }}
        >
          {details.join(" • ")}
        </Typography>
      </Box>
      {action && (
        <Box ml="auto" flexShrink={0}>
          {action}
        </Box>
      )}
    </Box>
  );
};
